import { cn } from '@joyful/utils'
import {
  FileIcon,
  FileImageIcon,
  FileSpreadsheetIcon,
  FileTextIcon,
} from 'lucide-react'
import type { LucideIcon, LucideProps } from 'lucide-react'

const fileTypeConfigByExtension = new Map<
  string,
  { className: string; icon: LucideIcon }
>([
  ['CSV', { className: 'text-emerald-700', icon: FileSpreadsheetIcon }],
  ['DOC', { className: 'text-blue-700', icon: FileTextIcon }],
  ['JPG', { className: 'text-purple-700', icon: FileImageIcon }],
  ['PDF', { className: 'text-red-700', icon: FileTextIcon }],
  ['PNG', { className: 'text-purple-700', icon: FileImageIcon }],
  ['WEBP', { className: 'text-purple-700', icon: FileImageIcon }],
  ['XLS', { className: 'text-emerald-700', icon: FileSpreadsheetIcon }],
])

export function resolveFileTypeIcon(fileName: string) {
  const fileTypeConfig = fileTypeConfigByExtension.get(
    fileExtensionLabel(fileName),
  )
  return {
    Icon: fileTypeConfig?.icon ?? FileIcon,
    className: fileTypeConfig?.className ?? 'text-tremor-content-subtle',
  }
}

export interface FileTypeIconProps extends LucideProps {
  fileName: string
}

export function FileTypeIcon({
  className,
  fileName,
  ...props
}: FileTypeIconProps) {
  const { Icon, className: colorClassName } = resolveFileTypeIcon(fileName)
  return <Icon className={cn(colorClassName, className)} {...props} />
}

const fileExtensionAliases = new Map<string, string>([
  ['DOCM', 'DOC'],
  ['DOCX', 'DOC'],
  ['DOT', 'DOC'],
  ['DOTM', 'DOC'],
  ['DOTX', 'DOC'],
  ['JPEG', 'JPG'],
  ['ODS', 'XLS'],
  ['ODT', 'DOC'],
  ['RTF', 'DOC'],
  ['XLSB', 'XLS'],
  ['XLSM', 'XLS'],
  ['XLSX', 'XLS'],
  ['XLT', 'XLS'],
  ['XLTM', 'XLS'],
  ['XLTX', 'XLS'],
])

function fileExtensionLabel(fileName: string) {
  const extension = fileName.split('.').at(-1)
  if (!extension) {
    return 'FILE'
  }

  const upperExtension = extension.toUpperCase()
  return fileExtensionAliases.get(upperExtension) ?? upperExtension
}
